/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, amount: NonNullable<unknown> }} Plan_Change_Next_InvoiceInputs */

const en_plan_change_next_invoice = /** @type {(inputs: Plan_Change_Next_InvoiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing due today. Your next invoice on ${i?.date} will be ${i?.amount}.`)
};

const es_plan_change_next_invoice = /** @type {(inputs: Plan_Change_Next_InvoiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No hay nada que pagar hoy. Tu próxima factura del ${i?.date} será de ${i?.amount}.`)
};

/**
* | output |
* | --- |
* | "Nothing due today. Your next invoice on {date} will be {amount}." |
*
* @param {Plan_Change_Next_InvoiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_next_invoice = /** @type {((inputs: Plan_Change_Next_InvoiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Next_InvoiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_next_invoice(inputs)
	return en_plan_change_next_invoice(inputs)
});